<template>
  <div class="container mt-4 mb-4">
    <div class="card">
      <div class="card-header bg-dark text-white">
        <h4 class="mb-0">
          <font-awesome-icon icon="trophy" class="me-2" />
          Sorteio: {{ prizedraw?.name }}
        </h4>
      </div>
      <div class="card-body mb-4">

        <div class="row justify-content-center mb-3">
          <div class="text-center">
            <img 
              :src="prizedraw.image" 
              alt="imagem do sorteio"
              height="250"
              class="rounded"
            >
          </div>
        </div>

        <!-- Filtro -->
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="input-group" :hidden="startPrizeDraw">
              <span class="input-group-text">
                <font-awesome-icon icon="search" />
              </span>
              <input 
                type="text" 
                class="form-control" 
                placeholder="Buscar cliente..." 
                v-model="searchTerm"
              />
            </div>
          </div>
          <div class="col-md-6 text-end">
            <button 
              class="btn btn-primary me-2" 
              @click="setStartPrizeDraw"
              :disabled="availableClients.length === 0"
              v-if="!startPrizeDraw"
            >
              <font-awesome-icon icon="random" class="me-2" />
              Ir para Sorteio
            </button>
            <button 
              class="btn btn-outline-danger" 
              @click="resetSelection"
              v-if="advantageClients.length > 0 && !startPrizeDraw"
            >
              <font-awesome-icon icon="redo" class="me-2" />
              Remover Seleção
            </button>
            <!-- Botões de inicialização verdadeiro -->
            <button 
              class="btn btn-warning me-2" 
              @click="goStartPrizeDraw"
              v-if="startPrizeDraw"
            >
              <font-awesome-icon icon="trophy" class="me-2" />
              Iniciar Sorteio
            </button>
            <!-- <button 
              class="btn btn-outline-danger" 
              @click="setStartPrizeDraw"
              v-if="startPrizeDraw"
            >
              <font-awesome-icon icon="redo" class="me-2" />
              Cancelar
            </button> -->
          </div>
        </div>

        <!-- Colunas de arraste -->
        <div class="row">
          <!-- Clientes disponíveis geral -->
          <div class="col-md-12" v-if="startPrizeDraw">
            <div class="card h-100">
              <div class="card-header bg-light">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Todos os Clientes</h5>
                  <span class="badge bg-primary">{{ prizedrawClient.length + 150}}</span>
                </div>
              </div>
              <div class="card-body client-list" ref="availableContainer">
                <div class="list-group">
                  <div 
                    v-for="client in prizedrawClient" 
                    :key="client.id"
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div class="fw-bold">{{ client.name }}</div>
                      <small class="text-muted">Qtd Cupons: {{ client.coupon }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Clientes disponíveis -->
          <div class="col-md-6" v-if="!startPrizeDraw">
            <div class="card h-100">
              <div class="card-header bg-light">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Todos os Clientes</h5>
                  <span class="badge bg-primary">{{ filteredAvailableClients.length}}</span>
                </div>
              </div>
              <div class="card-body client-list" ref="availableContainer">
                <div class="list-group">
                  <div 
                    v-for="client in filteredAvailableClients" 
                    :key="client.id"
                    class="list-group-item d-flex justify-content-between align-items-center"
                    draggable="true"
                    @dragstart="dragStart($event, client, 'available')"
                    @dragover.prevent
                    @drop="onDrop($event, 'available')"
                  >
                    <div>
                      <div class="fw-bold">{{ client.name }}</div>
                      <small class="text-muted">Qtd Cupons: {{ client.coupon }}</small>
                    </div>
                    <button 
                      class="btn btn-sm btn-outline-success" 
                      @click="moveToAdvantage(client)"
                    >
                      <font-awesome-icon icon="arrow-right" />
                    </button>
                  </div>
                </div>
                <div v-if="filteredAvailableClients.length === 0" class="text-center p-3">
                  <p class="text-muted">Nenhum cliente disponível</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Clientes com vantagem -->
          <div class="col-md-6" v-if="!startPrizeDraw">
            <div class="card h-100">
              <div class="card-header bg-success text-white">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Clientes com Vantagem</h5>
                  <span class="badge bg-light text-dark">{{ filteredAdvantageClients.length }}</span>
                </div>
              </div>
              <div class="card-body client-list" ref="advantageContainer"
                   @dragover.prevent
                   @drop="onDrop($event, 'advantage')">
                <div class="list-group">
                  <div 
                    v-for="client in filteredAdvantageClients" 
                    :key="client.id"
                    class="list-group-item d-flex justify-content-between align-items-center"
                    draggable="true"
                    @dragstart="dragStart($event, client, 'advantage')"
                  >
                    <div>
                      <div class="fw-bold">{{ client.name }}</div>
                      <small class="text-muted">Qtd Cupons: {{ client.coupon }}</small>
                    </div>
                    <button 
                      class="btn btn-sm btn-outline-danger" 
                      @click="moveToAvailable(client)"
                    >
                      <font-awesome-icon icon="arrow-left" />
                    </button>
                  </div>
                </div>
                <div v-if="filteredAdvantageClients.length === 0" class="text-center p-3">
                  <p class="text-muted">Nenhum cliente com vantagem selecionado</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Lista de ganhadores - Aparece somente após algum sorteio -->
        <div class="row mt-4" v-if="winners.length > 0">
          <div class="col-12">
            <div class="card">
              <div class="card-header bg-warning text-dark">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Ganhadores</h5>
                  <span class="badge bg-dark">{{ winners.length }}</span>
                </div>
              </div>
              <div class="card-body client-list" style="max-height: 100px !important;">
                <div class="list-group">
                  <div 
                    v-for="(winner, index) in winners" 
                    :key="`winner-${winner.id}-${index}`"
                    class="list-group-item"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <div class="fw-bold">{{ winner.name }}</div>
                        <small class="text-muted">Cupons: {{ winner.coupon }}</small>
                      </div>
                      <span class="badge bg-success rounded-pill">
                        Sorteio #{{ winner.drawNumber }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botões de ação -->
        <div class="row mt-4 mb-4">
          <div class="col-12 text-end">
            <button class="btn btn-secondary me-2" @click="closeModal">
              <font-awesome-icon icon="times" class="me-2" />
              <router-link 
                to="/prizedraw" 
                class="mb-2 col-lg-2 col-md-4 col-sm-5"
                style="color: white;text-decoration: none;padding-left: 40px; padding-right: 40px;"
                >
                Voltar
              </router-link>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Confetti animation for winners -->
    <div v-if="showConfetti" class="confetti-container">
      <canvas ref="confettiCanvas" class="confetti"></canvas>
    </div>

    <!-- Modal de Sorteio - Agora controlado pelo Vue -->
    <div v-if="isModalVisible" class="modal-backdrop fade show"></div>
    <div v-if="isModalVisible" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="drawModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-dark text-white">
            <h5 class="modal-title" id="drawModalLabel">
              <font-awesome-icon icon="trophy" class="me-2" />
              {{ prizedraw?.name }}
            </h5>
          </div>
          
          <!-- Contagem regressiva -->
          <div v-if="countdownActive" class="countdown-overlay">
            <div class="countdown-number" :style="{ color: countdownColor }">
              {{ countdownNumber }}
            </div>
          </div>
          
          <div class="modal-body p-0">
            <div class="draw-animation-container">
              <!-- Animação antes de revelar o vencedor -->
              <div v-if="drawInProgress" class="draw-animation">
                <div class="draw-timer text-center mb-4">
                  <div class="progress" style="height: 10px;">
                    <div 
                      class="progress-bar progress-bar-striped progress-bar-animated bg-warning" 
                      role="progressbar" 
                      :style="`width: ${animationProgress}%`"
                    ></div>
                  </div>
                  <div class="mt-2">{{ Math.ceil(remainingTime / 1000) }} segundos restantes</div>
                </div>

                <div class="spinning-names-container">
                  <div class="spinning-names">
                    <div v-for="(name, index) in displayNames" :key="index" 
                         class="spinning-name" 
                         :class="{ active: index === activeNameIndex }">
                      {{ 'sorteando...' }}
                    </div>
                  </div>
                </div>

                <div class="draw-info text-center mt-4">
                  <h4>Sorteando</h4>
                  <p class="text-muted">Aguarde enquanto selecionamos o ganhador...</p>
                </div>
              </div>

              <!-- Exibição do vencedor -->
              <div v-else class="winner-reveal">
                <div class="text-center py-4">
                  <div class="winner-trophy mb-3">
                    <font-awesome-icon icon="trophy" class="trophy-icon" />
                  </div>
                  <h2 class="winner-label mb-3">Ganhador:</h2>
                  <div class="winner-name">{{ selectedWinner?.name }}</div>
                  <div class="winner-info mt-3">
                    <span class="badge bg-success rounded-pill mb-2">Sorteio #{{ drawCount }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-secondary" 
              :disabled="drawInProgress" 
              @click="closeModal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import store from "../../store";
import { nextTick } from 'vue';

export default {
  name: 'PrizeDraw',
  setup() {
    const prizedraw = computed(() => store.state.prizedraw || {});
    const prizedrawClient = computed(() => store.state.prizedrawClient || []);

    const availableClients = ref([]);
    const advantageClients = ref([]);
    const winners = ref([]);
    const searchTerm = ref('');
    const showConfetti = ref(false);
    const confettiCanvas = ref(null);
    const drawCount = ref(0);
    
    // Modal e animação do sorteio
    const isModalVisible = ref(false);
    const drawInProgress = ref(false);
    const isAdvantageDraw = ref(false);
    const startPrizeDraw = ref(false);
    const selectedWinner = ref(null);
    const remainingTime = ref(60000); // 60 segundos em milissegundos
    const animationProgress = ref(0);
    const activeNameIndex = ref(0);
    const displayNames = ref([]);
    const animationInterval = ref(null);
    const progressInterval = ref(null);
    
    // Contagem regressiva
    const countdownActive = ref(false);
    const countdownNumber = ref(10);
    const countdownColor = ref('#ff0000');
    const countdownInterval = ref(null);
    const countdownColors = [
      '#ff0000', // vermelho
      '#ff7700', // laranja
      '#ffdd00', // amarelo
      '#00cc00', // verde
      '#0099ff', // azul
      '#6600cc', // roxo
      '#ff00ff', // magenta
      '#00cccc', // ciano
      '#ff9966', // salmão
      '#66cc66'  // verde claro
    ];
    
    let confettiInstance = null;
    let draggedItem = null;
    let sourceList = null;

    // Filter clients based on search term
    const filteredAvailableClients = computed(() => {
      if (!searchTerm.value) return availableClients.value;
      const term = searchTerm.value.toLowerCase();
      return availableClients.value.filter(client => 
        client.name.toLowerCase().includes(term)
      );
    });

    const filteredAdvantageClients = computed(() => {
      if (!searchTerm.value) return advantageClients.value;
      const term = searchTerm.value.toLowerCase();
      return advantageClients.value.filter(client => 
        client.name.toLowerCase().includes(term)
      );
    });

    // Initialize the lists
    const initializeLists = () => {
      // Get prizedraw clients from store and load them into available clients
      availableClients.value = [...prizedrawClient.value];
      advantageClients.value = [];
      // Keep winners as they are - they persist across reset of selections
    };

    // Handle drag start
    const dragStart = (event, client, source) => {
      draggedItem = client;
      sourceList = source;
      event.dataTransfer.effectAllowed = 'move';
      // For Firefox compatibility
      event.dataTransfer.setData('text/plain', client.id);
    };

    // Handle drop
    const onDrop = (event, target) => {
      event.preventDefault();
      
      if (!draggedItem) return;
      
      // If source and target are the same, do nothing
      if (sourceList === target) return;
      
      if (target === 'advantage') {
        moveToAdvantage(draggedItem);
      } else {
        moveToAvailable(draggedItem);
      }
      
      draggedItem = null;
      sourceList = null;
    };

    // Move client to advantage group
    const moveToAdvantage = (client) => {
      const index = availableClients.value.findIndex(c => c.id === client.id);
      if (index !== -1) {
        availableClients.value.splice(index, 1);
        advantageClients.value.push({...client});
      }
    };

    // Move client back to available
    const moveToAvailable = (client) => {
      const index = advantageClients.value.findIndex(c => c.id === client.id);
      if (index !== -1) {
        advantageClients.value.splice(index, 1);
        availableClients.value.push({...client});
      }
    };

    // Check if client has already won
    const hasAlreadyWon = (clientId) => {
      return winners.value.some(winner => winner.id === clientId);
    };

    // Iniciar sorteio aleatório padrão
    const startStandardDraw = () => {
      isAdvantageDraw.value = false;
      prepareDrawAnimation();
      showDrawModal();
    };

    // Iniciar sorteio com vantagem
    const startAdvantageBasedDraw = () => {
      isAdvantageDraw.value = true;
      prepareDrawAnimation();
      showDrawModal();
    };

    // Abrir o modal
    const showDrawModal = () => {
      isModalVisible.value = true;
      // Adicionar classe ao body para prevenir scroll
      document.body.classList.add('modal-open');
      // Não chamar startDrawAnimation() aqui, pois será chamado após a contagem
    };

    // Fechar o modal
    const closeModal = () => {
      isModalVisible.value = false;
      document.body.classList.remove('modal-open');
      
      // Limpar os intervalos
      if (animationInterval.value) clearInterval(animationInterval.value);
      if (progressInterval.value) clearInterval(progressInterval.value);
      if (countdownInterval.value) clearInterval(countdownInterval.value);
      
      countdownActive.value = false;
    };

    // Iniciar a contagem regressiva
    const startCountdown = () => {
      countdownActive.value = true;
      countdownNumber.value = 3;
      
      // Escolher cor aleatória inicial
      countdownColor.value = countdownColors[Math.floor(Math.random() * countdownColors.length)];
      
      if (countdownInterval.value) {
        clearInterval(countdownInterval.value);
      }
      
      countdownInterval.value = setInterval(() => {
        countdownNumber.value -= 1;
        
        // Mudar cor a cada segundo
        countdownColor.value = countdownColors[Math.floor(Math.random() * countdownColors.length)];
        
        if (countdownNumber.value <= 0) {
          clearInterval(countdownInterval.value);
          countdownActive.value = false;
          // Continuar com o sorteio original após a contagem
          startDrawAnimation();
        }
      }, 1000);
    };

    // Preparar a animação do sorteio
    const prepareDrawAnimation = () => {
      // Obter todos os nomes de clientes elegíveis para exibir na animação
      const allEligibleClients = [...availableClients.value, ...advantageClients.value]
        .filter(client => !hasAlreadyWon(client.id))
        .map(client => client.name);
      
      // Se não houver clientes elegíveis, mostrar mensagem e abortar
      if (allEligibleClients.length === 0) {
        // alert('Não há clientes elegíveis disponíveis para o sorteio.');
        return;
      }
      
      // Duplicar nomes para ter mais movimento na animação
      displayNames.value = [...allEligibleClients];
      while (displayNames.value.length < 20) {
        displayNames.value = [...displayNames.value, ...allEligibleClients];
      }
      
      // Embaralhar nomes para animação
      displayNames.value = displayNames.value.sort(() => Math.random() - 0.5).slice(0, 30);
      
      // Resetar estado de animação
      drawInProgress.value = true;
      selectedWinner.value = null;
      remainingTime.value = 3000; // Reduzido para 3 segundos após a contagem regressiva
      animationProgress.value = 0;
      activeNameIndex.value = 0;
      
      // Iniciar a contagem regressiva
      startCountdown();
    };

    // Iniciar a animação do sorteio
    const startDrawAnimation = () => {
      // Limpar intervalos anteriores se existirem
      if (animationInterval.value) clearInterval(animationInterval.value);
      if (progressInterval.value) clearInterval(progressInterval.value);
      
      // Atualizar o índice do nome ativo a cada 100ms
      animationInterval.value = setInterval(() => {
        activeNameIndex.value = (activeNameIndex.value + 1) % displayNames.value.length;
      }, 100);
      
      // Atualizar o progresso e o tempo restante a cada 100ms
      const startTime = Date.now();
      const duration = remainingTime.value; // Usando o valor de remainingTime
      
      progressInterval.value = setInterval(() => {
        const elapsed = Date.now() - startTime;
        remainingTime.value = Math.max(0, duration - elapsed);
        animationProgress.value = (elapsed / duration) * 100;
        
        // Quando a animação terminar, executar o sorteio real
        if (elapsed >= duration) {
          clearInterval(animationInterval.value);
          clearInterval(progressInterval.value);
          completeDraw();
        }
      }, 100);
    };
    
    const setStartPrizeDraw = () => {
      startPrizeDraw.value = startPrizeDraw.value ? false : true;
    }

    const goStartPrizeDraw = () => {

      winners.value.forEach((value) => {
        advantageClients.value = advantageClients.value.filter(item => item.id !== value.id);
      });

      if(advantageClients.value.length > 0){
        startAdvantageBasedDraw();
      }else{
        startStandardDraw();
      }
    }
    // Concluir o sorteio após a animação
    const completeDraw = () => {
      drawInProgress.value = false;
      drawCount.value++;
      showConfetti.value = true;  
      // Executar o sorteio adequado com base no tipo
      if (isAdvantageDraw.value) {
        runAdvantageBasedDraw();
      } else {
        runStandardDraw();
      }
      // Exibir confetti
      
      // if (confettiCanvas.value) {
        startConfetti();
      // }
    };

    // Run standard random draw (from all available clients)
    const runStandardDraw = () => {
      // Filter out clients who already won
      const eligibleClients = availableClients.value.filter(client => !hasAlreadyWon(client.id));
      
      if (eligibleClients.length === 0) {
        // alert('Não há clientes elegíveis disponíveis para o sorteio.');
        return;
      }
      
      // Create a weighted pool based on coupon counts
      let pool = [];
      eligibleClients.forEach(client => {
        for (let i = 0; i < client.coupon; i++) {
          pool.push(client);
        }
      });
      
      // Shuffle the pool (Fisher-Yates algorithm)
      for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      
      // Select a winner
      if (pool.length > 0) {
        const winner = {...pool[0], drawNumber: drawCount.value};
        winners.value.push(winner);
        selectedWinner.value = winner;
      }
    };

    // Run draw with advantage (ONLY from advantage clients)
    const runAdvantageBasedDraw = () => {
      const eligibleAdvantageClients = advantageClients.value.filter(client => !hasAlreadyWon(client.id));
      
      if (eligibleAdvantageClients.length === 0) {
        return;
      }
      
      // Seleciona o primeiro cliente
      const winner = {...eligibleAdvantageClients[0], drawNumber: drawCount.value};
      winners.value.push(winner);
      selectedWinner.value = winner;
    };

    // Reset the selection (but not winners)
    const resetSelection = () => {
      initializeLists();
      showConfetti.value = false;
      if (confettiInstance) {
        confettiInstance.reset();
      }
    };

    // Save results to store/backend
    const saveResults = () => {
      // Here you would dispatch an action to save the winners to your backend
      // For now, we'll just simulate success
      // alert('Resultados do sorteio salvos com sucesso!');
      
      // If you have the action in your store:
      /*
      store.dispatch('saveDrawWinners', {
        prizeDrawId: prizedraw.value?.id,
        winners: winners.value
      }).then(() => {
        alert('Resultados do sorteio salvos com sucesso!');
      }).catch(error => {
        console.error('Error saving winners:', error);
        alert('Ocorreu um erro ao salvar os resultados');
      });
      */
    };

    // Confetti animation
    const startConfetti = () => {
      // Primeiro, certifique-se de que o container esteja visível
      showConfetti.value = true;
      
      // Aguardar um tick para garantir que o Vue renderize o canvas no DOM
      nextTick(() => {
        if (!window.confetti) {
          console.error('Biblioteca de confetti não disponível');
          return;
        }
        
        if (!confettiCanvas.value) {
          console.error('Canvas de confetti não encontrado');
          return;
        }
        
        try {
          confettiInstance = window.confetti.create(confettiCanvas.value, {
            resize: true,
            useWorker: true
          });
          
          confettiInstance({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 }
          });
          
          // Auto-stop após alguns segundos
          setTimeout(() => {
            if (confettiInstance) {
              confettiInstance.reset();
            }
            // Não definimos showConfetti como false aqui para evitar problemas
            // com a instância do confetti. Isso acontecerá em outro lugar.
          }, 5000);
        } catch (error) {
          console.error('Erro ao executar confetti:', error);
        }
      });
    };

    // Keyboard event handler for ESC key
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isModalVisible.value && !drawInProgress.value) {
        closeModal();
      }
    };

    const loadConfettiLibrary = () => {
      return new Promise((resolve, reject) => {
        if (window.confetti) {
          resolve(window.confetti);
          return;
        }
        
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js';
        script.async = true;
        
        script.onload = () => resolve(window.confetti);
        script.onerror = () => reject(new Error('Falha ao carregar a biblioteca confetti'));
        
        document.head.appendChild(script);
      });
    };

    onMounted(async () => {
      
      await store.dispatch('onGetPrizeDraw');
      await store.dispatch('onGetPrizeDrawClient');

      initializeLists();
  
      // Carregar biblioteca confetti
      await loadConfettiLibrary().catch(err => console.error(err));
      
      // Add ESC key listener
      window.addEventListener('keydown', handleKeyDown);

      // Import confetti library
      // if (!window.confetti) {
      //   const script = document.createElement('script');
      //   script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js';
      //   script.async = true;
      //   document.head.appendChild(script);
      // }
      
      // // Add ESC key listener
      // window.addEventListener('keydown', handleKeyDown);
    });

    onBeforeUnmount(() => {
      if (confettiInstance) {
        confettiInstance.reset();
      }
      
      // Limpar os intervalos
      if (animationInterval.value) clearInterval(animationInterval.value);
      if (progressInterval.value) clearInterval(progressInterval.value);
      if (countdownInterval.value) clearInterval(countdownInterval.value);
      
      // Remove ESC key listener
      window.removeEventListener('keydown', handleKeyDown);
      
      // Garantir que modal-open seja removido do body
      document.body.classList.remove('modal-open');
    });

    return {
      prizedraw,
      prizedrawClient,
      availableClients,
      advantageClients,
      winners,
      searchTerm,
      filteredAvailableClients,
      filteredAdvantageClients,
      showConfetti,
      confettiCanvas,
      moveToAdvantage,
      moveToAvailable,
      startStandardDraw,
      startAdvantageBasedDraw,
      resetSelection,
      saveResults,
      dragStart,
      onDrop,
      // Modal e animação
      isModalVisible,
      closeModal,
      drawInProgress,
      isAdvantageDraw,
      selectedWinner,
      remainingTime,
      animationProgress,
      displayNames,
      activeNameIndex,
      drawCount,
      // Contagem regressiva
      countdownActive,
      countdownNumber,
      countdownColor,
      startPrizeDraw,
      setStartPrizeDraw,
      goStartPrizeDraw,
    };
  }
};
</script>

<style scoped>
/* Adicione estes estilos à sua seção <style> */
.countdown-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.countdown-number {
  font-size: 15rem;
  font-weight: bold;
  animation: pulse 1s infinite;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(0.8);
  }
}
.client-list {
  max-height: 200px;
  overflow-y: auto;
}

.list-group-item {
  cursor: grab;
  transition: all 0.2s ease;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.list-group-item:active {
  cursor: grabbing;
}

.confetti-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}

.confetti {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Estilos para a modal e animação do sorteio */
.draw-animation-container {
  min-height: 500px;
  position: relative;
  background-color: #f8f9fa;
}

.draw-animation, .winner-reveal {
  padding: 2rem;
}

.spinning-names-container {
  height: 200px;
  overflow: hidden;
  position: relative;
  background: linear-gradient(to bottom, 
    rgba(255,255,255,1) 0%, 
    rgba(255,255,255,0) 10%, 
    rgba(255,255,255,0) 90%, 
    rgba(255,255,255,1) 100%);
}

.spinning-names {
  text-align: center;
  padding: 70px 0;
}

.spinning-name {
  font-size: 1.5rem;
  opacity: 0.3;
  transition: all 0.2s ease;
  margin: 0.5rem 0;
  transform: scale(0.9);
}

.spinning-name.active {
  font-size: 2.5rem;
  opacity: 1;
  font-weight: bold;
  color: #007bff;
  transform: scale(1);
}

.trophy-icon {
  font-size: 5rem;
  color: gold;
  animation: pulse 1.5s infinite;
}

.winner-label {
  color: #6c757d;
}

.winner-name {
  font-size: 3rem;
  font-weight: bold;
  color: #28a745;
  padding: 1rem;
  margin: 1rem 0;
  background-color: rgba(40, 167, 69, 0.1);
  border-radius: 10px;
  animation: winnerReveal 1s;
}


/* Para deixar o modal maior */
.modal-dialog.modal-lg {
  max-width: 900px;
  width: 90%; 
}
/* Estilos para o modal Vue (sem Bootstrap JS) */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: rgb(250, 250, 250) !important; /* Aumentando para 0.9 com !important */
  opacity: 0.9 !important;
}

.modal {
  z-index: 1050;
}

.modal.show {
  display: block;
}

.d-block {
  display: block !important;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes winnerReveal {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>